import BasePolicy from '@/policies/BasePolicy.js';

export default class MessagePolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view all messages');
    }

    view(user, message) {
        return user.hasPermissionTo('view a message');
    }

    create(user) {
        return user.hasPermissionTo('create a message');
    }

    update(user, message) {
        return user.hasPermissionTo('edit a message');
    }

    delete(user, message) {
        return user.hasPermissionTo('delete a message');
    }
}
